import React from 'react';
import { Paper, Box, Grid, Typography } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';

import Features from './components/Features';
import useCar from '../../../../context/useCar';
import { useIsDesktop, useTranslations } from 'components/utilities';

const CarDetailsFeatures = ({ boxSizes }) => {
	const { t } = useTranslations();

	const {
		carDetails: { car },
	} = useCar();

	const isDriverAvailable = car.office.driver || false;

	const isUnlimitedKmAvailable = car.unlimited_km || false;

	const someFeatureAvailable = [isDriverAvailable, isUnlimitedKmAvailable].some(
		(feature) => feature
	);

	const isDesktop = useIsDesktop()

	if ( !someFeatureAvailable ) {
		return null;
	}

	return (
		<Paper>
			<Box {...boxSizes}>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs="auto">
						<ScheduleIcon fontSize="large" style={!isDesktop ? { width: 24, height: 24 } : null} />
					</Grid>
					<Grid item xs="auto">
						<Typography variant="h5" gutterBottom>
							{t('car.additionalServices')}
						</Typography>
					</Grid>
				</Grid>
				<Box py={2}>
					<Features />
				</Box>
			</Box>
		</Paper>
	);
};

export default CarDetailsFeatures;
